import { useGetMyIntroductions } from '@queries/introductions';
import { useAuthStore } from '@sunrise-ui/primitives';
import { findIntro } from '@utils/introductions';

export default function useMyIntroById({ introId }: { introId?: string }) {
  const { currentUserId } = useAuthStore();
  const { isLoading: isLoadingPendingIntros, data: pendingIntros } =
    useGetMyIntroductions({
      userId: currentUserId,
      state: 'pending',
    });
  const { isLoading: isLoadingAcceptedIntros, data: acceptedIntros } =
    useGetMyIntroductions({
      userId: currentUserId,
      state: 'accepted',
    });
  const { isLoading: isLoadingDeniedIntros, data: deniedIntros } =
    useGetMyIntroductions({
      userId: currentUserId,
      state: 'denied',
    });

  const isLoading =
    isLoadingPendingIntros || isLoadingAcceptedIntros || isLoadingDeniedIntros;
  const introductions = [
    ...(pendingIntros ?? []),
    ...(acceptedIntros ?? []),
    ...(deniedIntros ?? []),
  ];

  const intro = findIntro(introductions, introId);
  const currentUserHalf = intro?.introduction.find(
    (iHalf) => iHalf.introduced_to.id === introId,
  );
  const otherUserHalf = intro?.introduction.find(
    (iHalf) => iHalf.introduced_to.id !== introId,
  );

  const isRequestor = currentUserHalf?.introduced_to.intro_role === 'requestor';
  const isAcceptor = currentUserHalf?.introduced_to.intro_role === 'acceptor';

  return { isLoading, currentUserHalf, otherUserHalf, isRequestor, isAcceptor };
}
